




































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MonitoringTrombolisisKpiHeader extends Vue {
  @Prop() monitoring!: any;

  get faseColor() {
    const colors: Record<string, string> = {
      infus: "red",
      "0_2h": "orange",
      "2_8h": "amber darken-2",
      "8_24h": "blue",
      selesai: "green",
    };
    return colors[this.monitoring?.current_fase] || "grey";
  }
}
